<!-- 買う/使う一覧のチケット名表示 -->
<template>
  <div class="list-item__title">
    {{ name }}
  </div>
</template>

<script>
export default {
  name: "MbIndexNameDisp",
  props: {
    name: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.list-item__title {
  font-size: 14px !important;
  position: absolute;
  top: 13%;
  overflow: hidden;
  font-weight: bold;
}

@media screen and (min-width: 421px) {
  .list-item__title {
    font-size: 4vw !important;
    top: 7%;
  }
}
</style>
